import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import * as authActions from '../actions/auth.actions';
import { AuthService } from '@auth/services/auth.service';

@Injectable()
export class AuthEffetcs {
  token: string = null;
  constructor(private actions$: Actions, private authService: AuthService) {}

  loginModule$ = createEffect(() =>
    this.actions$.pipe(
      ofType(authActions.LOGIN_REQUEST),
      mergeMap(({ userCredentialsLogin }) =>
        this.authService.validateUserCredentials(userCredentialsLogin).pipe(
          map(({ item, token }) => {
            if (item) {
              return authActions.LOGIN_SUCCESS({ user: item, token });
            } else return authActions.LOGIN_FAILED();
          }),
          catchError((err) => of(authActions.LOGIN_REQUEST_FAILED({ payload: err }))),
        ),
      ),
    ),
  );
}
//TODO: comentar
